export default __webpack_public_path__ + "static/media/card3.ba6b9934.png";